// Merkan · Leiste für "Ansicht als" (BR-06): deutlich sichtbar, Ende per Klick
import { Eye } from 'lucide-react';
import { useSession } from '../lib/session';
import { t } from '../lib/sprache';
import { Knopf } from './index';
import './paket4.css';

export function AnsichtAlsLeiste() {
  const { ansichtAls, ansichtBeenden } = useSession();
  if (!ansichtAls) return null;
  return (
    <div className="p4-ansicht-leiste nicht-drucken" role="status" data-tour="ansicht-als-leiste">
      <Eye aria-hidden />
      <span className="p4-ansicht-text">
        <strong>{t('Ansicht als {rolle}', { rolle: t(ansichtAls.name) })}</strong>
        <span className="p4-ansicht-neben">{t('Nur Anzeige, Änderungen sind gesperrt.')}</span>
      </span>
      <Knopf className="p4-ansicht-ende" onClick={() => { void ansichtBeenden(); }}>{t('Ansicht beenden')}</Knopf>
    </div>
  );
}
